module.exports = __webpack_public_path__ + "media/offers_icons/rolnicze-white-5e33e791.svg";